import React from 'react';
import { Col, FormModal, Row } from 'components';
import { useAddCommercialOffer } from 'feature/dealTabs/commercialOffers/addCommercialOffer/useAddCommercialOffer';
import { RelationCard } from './relation/RelationCard';
import { RelationForm } from './relation/RelationForm';
import { Form, Typography } from 'antd';
import { ValidationErrors } from 'constants/validations';

const { Text } = Typography;

export interface IAddCommercialOfferModal {
  modalState: boolean;
  onModalStateChange: () => void;
  id: string;
}

export const AddCommercialOfferModal: React.FC<IAddCommercialOfferModal> = (props) => {
  const { onModalStateChange, modalState, id } = props;
  // const { hasAccess } = useAccessControl();
  const {
    onFinish,
    form,
    onCancel,
    isLoading,
    relations,
    onRelationItemSave,
    relationEdit,
    onRelationItemCancel,
    onRelationItemRemove,
    onRelationItemEdit,
  } = useAddCommercialOffer({ onModalStateChange, id });
  return (
    <FormModal
      form={form}
      title={'Add Commercial Offer'}
      okText={'Add'}
      open={modalState}
      isLoading={isLoading}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <Text style={{ color: '#05796B', fontWeight: 800 }}>Relation</Text>
        </Col>
        {!!relations.length && (
          <Col span={24}>
            <Row gutter={[0, 6]}>
              {relations.map((_relation) => (
                <RelationCard
                  onSave={onRelationItemSave}
                  onCancel={onRelationItemCancel}
                  onRemove={onRelationItemRemove}
                  onEdit={onRelationItemEdit}
                  form={form}
                  data={_relation}
                  key={_relation.relationBrand + _relation.relationSupplierOffer}
                  relationList={relations}
                  isEditeMode={
                    _relation.relationBrand === relationEdit?.brand &&
                    _relation.relationSupplierOffer === relationEdit?.supplierOffer
                  }
                />
              ))}
            </Row>
          </Col>
        )}
        <Col span={24}>
          <RelationForm form={form} onSave={onRelationItemSave} relationList={relations} />
        </Col>
        <Form.Item
          name="hasRelation"
          rules={[{ required: true, message: ValidationErrors.required('At least one Relation') }]}
        />
      </Row>
    </FormModal>
  );
};
